import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "goal-title-wrapper" }
const _hoisted_2 = { class: "goal-content" }
const _hoisted_3 = { class: "goal-progress" }
const _hoisted_4 = { class: "progress-inner" }
const _hoisted_5 = { class: "progress-value" }
const _hoisted_6 = { class: "goal-info" }
const _hoisted_7 = { class: "info-section" }
const _hoisted_8 = { class: "info-row" }
const _hoisted_9 = { class: "info-value" }
const _hoisted_10 = { class: "status-chip" }

import { ref, computed } from 'vue'
import UserGoal from '../../../api/v2/models/user_goal'
import ChartProgress from './ChartProgress.vue'
import { format } from 'date-fns'
import { checkMobile } from '../../utils/utils'

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'GoalSummary',
  props: {
    userGoal: {}
  },
  setup(__props: any) {

const props = __props

// Reactive Data
const mobile = ref(checkMobile())

// Functions
function dateFormat(date: string, formatDate: string = 'MM/DD'): string {
  return format(date, formatDate)
}

// Computed
const isLate = computed(() => props.userGoal.daysRemaining <= 0 && props.userGoal.progressRate < 100)
const isOnSchedule = computed(() => props.userGoal.daysRemaining > 0 && props.userGoal.progressRate < 100)

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["goal-summary", mobile.value ? 'pt-2 ps-1 pb-1' : 'pt-4 ps-6 pb-3'])
  }, [
    _createCommentVNode(" Title "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(mobile.value ? 'text-h5' : 'text-h4')
      }, _toDisplayString(__props.userGoal.goal.name), 3 /* TEXT, CLASS */)
    ]),
    _createCommentVNode(" Content: Progress Circle + Info "),
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Left: Progress Circle "),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_progress_circular, {
          class: _normalizeClass(mobile.value ? 'm-2' : 'm-3'),
          size: mobile.value ? 100 : 140,
          width: mobile.value ? 10 : 15,
          "model-value": __props.userGoal.progressRate,
          color: "rgba(255,255,255,0.3)",
          "bg-color": "rgba(255,255,255,0.15)"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "progress-label" }, "進捗率", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", {
                  class: _normalizeClass(mobile.value ? 'text-h6' : 'text-h3')
                }, _toDisplayString(__props.userGoal.progressRate), 3 /* TEXT, CLASS */),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "progress-percent" }, "%", -1 /* CACHED */))
              ])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["class", "size", "width", "model-value"])
      ]),
      _createCommentVNode(" Right: Info "),
      _createElementVNode("div", _hoisted_6, [
        _createCommentVNode(" 目標期間 "),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["info-label", mobile.value ? 'text-caption' : ''])
          }, "目標期間", 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["info-value", mobile.value ? 'text-caption' : 'text-h6'])
          }, _toDisplayString(dateFormat(__props.userGoal.startDate, 'YYYY/MM/DD')) + "～" + _toDisplayString(dateFormat(__props.userGoal.endDate, 'YYYY/MM/DD')), 3 /* TEXT, CLASS */)
        ]),
        _createCommentVNode(" 残り日数 + ステータス "),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass(["info-section", mobile.value ? 'mt-1' : 'mt-4'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["info-label", mobile.value ? 'text-caption' : ''])
            }, "残り日数", 2 /* CLASS */),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", {
                class: _normalizeClass(mobile.value ? 'text-h5' : 'text-h3')
              }, _toDisplayString(__props.userGoal.daysRemaining), 3 /* TEXT, CLASS */),
              _createElementVNode("span", {
                class: _normalizeClass(mobile.value ? 'text-caption' : '')
              }, "日", 2 /* CLASS */)
            ])
          ], 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["info-section status-section", mobile.value ? 'mt-1' : 'mt-4'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["info-label", mobile.value ? 'text-caption' : ''])
            }, "ステータス", 2 /* CLASS */),
            _createElementVNode("div", _hoisted_10, [
              (__props.userGoal.isOutSchedule)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    color: "red",
                    "text-color": "white",
                    size: mobile.value ? 'small' : 'default'
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode(" 遅れてます ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["size"]))
                : (__props.userGoal.isLate)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 1,
                      color: "green",
                      "text-color": "white",
                      size: mobile.value ? 'small' : 'default'
                    }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode(" やや遅れています ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["size"]))
                  : (__props.userGoal.isOnSchedule)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 2,
                        color: "white",
                        size: mobile.value ? 'small' : 'default'
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode(" 順調 ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["size"]))
                    : _createCommentVNode("v-if", true)
            ])
          ], 2 /* CLASS */)
        ])
      ])
    ])
  ], 2 /* CLASS */))
}
}

})